import { captureException } from '@sentry/react';
import { useSnackbar } from 'notistack';

import { useAuth } from 'shared/lib/auth/useAuth';
import { AuthHeroMessage } from 'shared/ui/AuthHeroMessage';

import { resendVerificationEmail } from './api';

export const UnverifiedEmail = () => {
  const { user } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  function handleResendClick() {
    if (user !== null) {
      resendVerificationEmail(user.id)
        .then(() => {
          enqueueSnackbar('Email sent');
        })
        .catch((error) => {
          captureException(error);
        });
    }
  }

  return (
    <AuthHeroMessage
      withSupport
      title="Verify your email"
      subtitle={
        <>
          An email has been sent to {user?.email}, click the button inside it. If you don't see the email in your inbox,
          check the spam folder or resend this email.
        </>
      }
      action={{ label: 'Resend email', onClick: handleResendClick }}
    />
  );
};
